import React from 'react';
import {StyledSimpleLinkButton} from "./SimpleLinkButton.styled";

interface SimpleLinkButtonProps {
    children: string | React.ReactNode;
    onClick: () => void;
}

const SimpleLinkButton = ({children, onClick}: SimpleLinkButtonProps) => {
    return (
        <StyledSimpleLinkButton variant='link' onClick={onClick}>
            {children}
        </StyledSimpleLinkButton>
    );
};

export default SimpleLinkButton;